export function getDescendentId(dropdownId, index) {
  return `${dropdownId}-${index}`;
}
